"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineHeader = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
const _contracts_1 = require("../../_contracts");
const LineHeader_contracts_1 = require("./LineHeader.contracts");
const LineHeader_config_1 = require("./LineHeader.config");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let LineHeader = class LineHeader extends vue_property_decorator_1.Vue {
    /**
     * The CSS class that sets the `font-weight` of the main content.
     */
    get fontWeightClass() {
        return this.isBold ? 'fw-bold' : 'fw-normal';
    }
    /**
     * The CSS class that controls the `--with-pointer` modifier class.
     */
    get pointerClass() {
        return this.showPointer && !this.siteImgClass ? '--with-pointer' : null;
    }
    /**
     * Full path to the site's logotype.
     */
    get siteImgClass() {
        if (typeof this.site === 'undefined') {
            return;
        }
        const className = LineHeader_config_1.siteLogoClassNameRegistry[this.site];
        if (typeof className !== 'string' || className.length === 0) {
            return;
        }
        return `--${this.theme}-${className}`;
    }
    /**
     * The CSS class that sets the color scheme (light/dark) of the component.
     */
    get themeClass() {
        return `--${this.theme}`;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LineHeader.prototype, "isBold", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LineHeader.prototype, "showPointer", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", String)
], LineHeader.prototype, "site", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: 'h2' }),
    __metadata("design:type", String)
], LineHeader.prototype, "tag", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: LineHeader_contracts_1.LineHeaderTheme.Light }),
    __metadata("design:type", String)
], LineHeader.prototype, "theme", void 0);
LineHeader = __decorate([
    vue_property_decorator_1.Component({
        name: 'LineHeader',
        components: { BootstrapImage: front_1.BootstrapImage },
        template: `
    <header class="line-header" :class="themeClass">
      <component :is="tag" class="line-header__content text-ui-separator text-uppercase m-0 mt-4 mb-3"
                 :class="[fontWeightClass, pointerClass]">
        <i v-if="siteImgClass" :class="siteImgClass" class="line-header__content__site-logo" />

        <span :class="siteImgClass ? 'subtitle' : null">
          <slot />
        </span>
      </component>

      <slot name="nav" />
    </header>
  `
    })
], LineHeader);
exports.LineHeader = LineHeader;
//# sourceMappingURL=LineHeader.js.map